// import COMPANY_API from '@/api/masterData/company.js';
export const searchColumns = (ctx) => {
  return [
    {
      name: '供应商',
      prop: 'supplierNo',
      type: 'searchTableSpec',
      searchType: 'partner',
      disabled: true,
      isMultiple: true,
      span: 7,
      // changeMethod: ctx.changeSupplyChainMethod,
      currentValue: ctx.query?.supplierName,
    },

    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
      disabled: true,
      span: 7,
    },

    {
      name: '结算单编号',
      prop: 'payableSettlementNo',
      type: 'input',
      span: 7,
    },
  ];
};

// 默认表头
export const defaultTableColumn = [
  {
    type: 'radio',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    field: 'contractName',
    title: '合同名称',
    visible: true,
  },
  {
    field: 'contractCode',
    title: '合同编号',
    visible: true,
  },

  {
    field: 'serviceName',
    title: '服务',
    visible: true,
  },
  {
    field: 'expenseName',
    title: '费用类型',
    visible: true,
  },
  {
    field: 'routeName',
    title: '线路',
    visible: true,
  },
  {
    field: 'departurePlaceName',
    title: '起始地',
    visible: true,
  },
  {
    field: 'destinationName',
    title: '目的地',
    visible: true,
  },
  {
    field: 'chargeUnit',
    title: '计费单位',
    visible: true,
  },
  {
    field: 'unitPriceWithTax',
    title: '计费单价（含税）',
    visible: true,
  },
];
export const tableList = [
  {
    id: 1,
    payableSettlementNo: 1111,
    settlementDesc: '说明',
    companyName: 'A',
    departmentName: 'b',
    originalTotalAmount: 1,
    domesticTotalAmount: 1,
    currencyName: 'TEST',
    contractNo: 66666,
    unitPriceWithTax: 88888,
    productName: '乐百氏',
  },
  {
    id: 2,
    payableSettlementNo: 2222,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 2,
    domesticTotalAmount: 2,
    currencyName: 'TEST',
    contractNo: 88888,
    unitPriceWithTax: 99999,
    productName: '可乐',
  },
  {
    id: 3,
    payableSettlementNo: 3333,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 3,
    domesticTotalAmount: 3,
    currencyName: 'TEST',
    contractNo: 88888,
    unitPriceWithTax: 99999,
    productName: '可乐',
  },
  {
    id: 4,
    payableSettlementNo: 4444,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 4,
    domesticTotalAmount: 4,
    currencyName: 'TEST',
    contractNo: 88888,
    unitPriceWithTax: 99999,
    productName: '可乐',
  },
  {
    id: 5,
    payableSettlementNo: 5555,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 5,
    domesticTotalAmount: 5,
    currencyName: 'TEST',
    contractNo: 88888,
    unitPriceWithTax: 99999,
    productName: '可乐',
  },
];
// 默认显示的按钮
export const defaultMenuBtnList = [
  // {
  //   id: 1,
  //   label: '新建',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'add',
  //   },
  // },
  // {
  //   id: 2,
  //   label: '启用',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'enable',
  //   },
  // },
  // {
  //   id: 3,
  //   label: '禁用',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'forbid',
  //   },
  // },
  {
    id: 4,
    label: '导出',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'export',
    },
  },
  // {
  //   id: 5,
  //   label: '批量导入',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //   },
  // },
  // {
  //   id: 6,
  //   label: '批准',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'approval',
  //   },
  // },
  // {
  //   id: 7,
  //   label: '驳回',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //   },
  // },
  {
    id: 8,
    label: '创建结算单',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'create',
    },
  },
];
